import createReactComponent from '../createReactComponent';
export default createReactComponent('circle-half', 'IconCircleHalf', [
  ['path', { d: 'M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0', key: 'svg-0' }],
  ['path', { d: 'M12 3v18', key: 'svg-1' }],
]);
